module.exports = __webpack_public_path__ + "img/vitamin.e374b300.png";